import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const MultiVendorEcommerceWebsiteDesignInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Multi-Vendor E-commerce Website Design in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Scale Your Marketplace</Subheading>}
        heading={
          <Heading>
            Multi-Vendor{" "}
            <span tw="text-primary-500">E-commerce Website Design</span> in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in multi-vendor e-commerce website
            design in **DIFC**, delivering robust, scalable platforms that
            empower vendors and delight customers. Build a thriving marketplace
            with cutting-edge design.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1518458028785-8fbcd101ebb9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Multi-vendor marketplace
          "https://images.unsplash.com/photo-1566241440091-ec10de8db2e1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Multiple stores/vendors
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Business collaboration
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build Your Marketplace"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Multi-Vendor Design in DIFC"
        description="We craft multi-vendor platforms with precision and scalability."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Vendor Management",
            description: "Streamlined tools for seamless vendor operations.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Customer-Centric",
            description: "Layouts optimized for trust and conversions.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Modern Aesthetics",
            description: "Visually appealing designs for DIFC markets.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "High Performance",
            description: "Fast, reliable platforms for growth.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimized",
            description: "Responsive designs for all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "DIFC’s choice for multi-vendor solutions.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Multi-Vendor Design Process"
        description={
          <Description>
            We create multi-vendor e-commerce websites with a strategic
            approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your marketplace vision.</li>
              <li>Design: Craft intuitive, vendor-friendly layouts.</li>
              <li>Development: Build scalable, secure platforms.</li>
              <li>Testing: Ensure flawless performance for all users.</li>
              <li>Launch: Deliver a robust marketplace ready to scale.</li>
              <li>Support: Provide ongoing optimization and support.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1472851294608-062f824d29cc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Marketplace development
          "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Business networking
          "https://images.unsplash.com/photo-1577401132920-f218ef9b01a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Development teamwork
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Marketplace Wins in DIFC"
        description="Our designs have transformed multi-vendor e-commerce."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Growth",
            description: "Tripled revenue with a new platform.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Reach",
            description: "Expanded visibility for DIFC vendors.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from marketplace clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for a Marketplace?</Subheading>}
        heading="Multi-Vendor E-commerce in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for multi-vendor e-commerce website
            design in DIFC. Launch a powerful, scalable marketplace that drives
            success—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team celebrating
          "https://images.unsplash.com/photo-1574362848149-11496d93a7c7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Multi-vendor concept
          "https://images.unsplash.com/photo-1560264280-88b68371db39?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Growth success
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
